module.exports = __webpack_public_path__ + "img/skillsA-4.3bd87be2.png";